import {
  AppBar,
  Button,
  Container,
  DialogContent,
  FormControlLabel,
  FormGroup,
  IconButton,
  Stack,
  Switch,
  TextField,
  Toolbar,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useFormik } from "formik";
import { connect } from "react-redux";

import { axios } from "../../commons";

const UserForm = ({ member, initialValues, onStartProcess, onClose }) => {
  const { errors, touched, values, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues:
        initialValues === true
          ? { patientCode: "", isApproved: false }
          : {
              ...initialValues,
              gender: initialValues.gender || "",
              birthYear: initialValues.birthYear || "",
              patientCode: initialValues.patientCode || "",
              isApproved: initialValues.approved
                ? initialValues.approved.isApproved
                : false,
            },
      validateOnMount: true,
      validate: ({ patientCode, isApproved, birthYear }) => {
        const result = {};

        if (isApproved && !patientCode) {
          result.patientCode = "필수!";
        }

        if (isNaN(birthYear)) {
          result.birthYear = "1985와 같이 넣어주세요.";
        }

        if (Number(birthYear) < 1900 || Number(birthYear) > 2100) {
          result.birthYear = "범위 : 1900~2100";
        }
        return result;
      },
      onSubmit: async (finalValues) => {
        const { id } = initialValues;
        onStartProcess();

        finalValues = {
          ...finalValues,
          birthYear: Number(finalValues.birthYear),
        };

        try {
          const { status } = await axios.patch(
            `/admin/users/${id}`,
            finalValues
          );

          console.log({ status });

          onClose(true);
        } catch (err) {
          console.error(err);

          if (err.response) {
            alert(err.response.data.error);
          }
        }
      },
    });

  const formProps = { onBlur: handleBlur, onChange: handleChange };

  return (
    <form onSubmit={handleSubmit}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            User - {initialValues.displayName}
          </Typography>
          <Button color="inherit" type="submit">
            save
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" component={DialogContent}>
        <Stack spacing={3}>
          <TextField
            variant="standard"
            label="메일 주소"
            value={initialValues.email}
            InputProps={{ readOnly: true }}
          />

          <TextField
            variant="standard"
            label="가입시 기재 실명"
            value={initialValues.name || "(가입 전)"}
            InputProps={{ readOnly: true }}
          />

          <TextField
            variant="standard"
            label="표시 이름"
            value={initialValues.displayName}
            InputProps={{ readOnly: true }}
          />

          <TextField
            variant="standard"
            label="진단명"
            value={initialValues.diagnosis || "(미기재)"}
            InputProps={{ readOnly: true }}
          />

          <TextField
            label="환자 코드"
            name="patientCode"
            value={values.patientCode}
            variant="filled"
            error={touched.patientCode && !!errors.patientCode}
            helperText={touched.patientCode && errors.patientCode}
            {...formProps}
          />

          <FormControl>
            <FormLabel id="gender-radio-buttons-group-label">성별</FormLabel>
            <RadioGroup
              aria-labelledby="gender-radio-buttons-group-label"
              name="gender"
              value={values.gender}
              onChange={handleChange}
              {...formProps}
            >
              <FormControlLabel value="male" control={<Radio />} label="남자" />
              <FormControlLabel
                value="female"
                control={<Radio />}
                label="여자"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="출생년도"
            name="birthYear"
            value={values.birthYear}
            variant="standard"
            error={!isNaN(touched.birthYear) && !!errors.birthYear}
            helperText={
              touched.birthYear && errors.birthYear
                ? touched.birthYear && errors.birthYear
                : "출생년도(4자리 기입)"
            }
            {...formProps}
          />

          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  name="isApproved"
                  checked={values.isApproved}
                  color={values.isApproved ? "success" : "default"}
                  {...formProps}
                />
              }
              label="승인 여부"
            />
          </FormGroup>
        </Stack>
      </Container>
    </form>
  );
};

const mapState = ({ auth: { member } }) => ({ member });

export default connect(mapState)(UserForm);
